export const PLANKTON_WEBMAP_ENABLED =
  process.env.REACT_APP_ENABLE_PLANKTON_WEBMAP === 'true'
